import { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { PrimaryButton, ReviewRating, SecondaryButton } from '../../../components';
import homeBanner1 from './assets/banner1.jpg';
import homeBanner2 from './assets/banner2.jpg';
import homeBanner3 from './assets/banner3.jpg';
import homeBanner4 from './assets/banner4.jpg';
import homeBanner5 from './assets/banner6.jpg';

import css from './SectionHero.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import Slider from 'react-slick';
import '../../../styles/slick/slick-theme.css';
import '../../../styles/slick/slick.css';

const testimonials = [
  {
    quote:
      '“Found the exact tiles I was hunting for and the seller shipped fast. The whole flow was seamless.”',
    name: 'Sarah J.',
    location: 'Austin, TX',
  },
  {
    quote:
      '“Listing my set took minutes, and I had serious buyers the same day. Love the community vibe.”',
    name: 'Monica P.',
    location: 'San Diego, CA',
  },
  {
    quote:
      '“Great selection and trusted sellers. I finally upgraded my racks and mat in one place.”',
    name: 'Lynn K.',
    location: 'Chicago, IL',
  },
];

const SliderArrow = ({ className, onClick, direction }) => (
  <button
    type="button"
    className={classNames(css.sliderArrow, className, {
      [css.sliderArrowPrev]: direction === 'prev',
      [css.sliderArrowNext]: direction === 'next',
    })}
    onClick={onClick}
    aria-label={direction === 'prev' ? 'Previous slide' : 'Next slide'}
  >
    <span aria-hidden="true">{direction === 'prev' ? '‹' : '›'}</span>
  </button>
);

function SectionHero(props) {
  const { intl, sliderSettings } = props;
  const history = useHistory();
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveTestimonial(prev => (prev + 1) % testimonials.length);
    }, 4500);

    return () => clearInterval(intervalId);
  }, []);

  const scrollToInstructors = () => {
    const section = document.getElementById('instructors-by-state');
    if (section) {
      const rootStyles = window.getComputedStyle(document.documentElement);
      const siteHeaderVar =
        window.innerWidth >= 1024 ? '--siteHeaderHeightDesktop' : '--siteHeaderHeight';
      const headerOffset = parseFloat(rootStyles.getPropertyValue(siteHeaderVar)) || 80;
      const top = section.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const resolvedSettings = useMemo(
    () => ({
      ...sliderSettings,
      prevArrow: <SliderArrow direction="prev" />,
      nextArrow: <SliderArrow direction="next" />,
    }),
    [sliderSettings]
  );

  return (
    <div className={css.heroSection}>
      <Slider {...resolvedSettings}>
        <div className={css.heroContentWrapper}>
          <div className={css.heroContentInner} style={{ backgroundImage: `url(${homeBanner1})` }}>
            <div className={css.heroContent}>
              <h1 className={css.pinkBubbleTitle}>
                {intl.formatMessage({ id: 'SectionHero.slide1.title' })}
              </h1>
              <p>{intl.formatMessage({ id: 'SectionHero.slide1.description' })}</p>
              <div className={css.btnsWrapper}>
                <PrimaryButton
                  className={classNames(css.heroButton, css.heroButtonPrimary)}
                  onClick={() => history.push('/s')}
                >
                  {intl.formatMessage({ id: 'SectionHero.shopNow' })}
                </PrimaryButton>
                <PrimaryButton
                  className={classNames(css.heroButton, css.heroButtonGreen)}
                  onClick={() => history.push('/l/new')}
                >
                  {intl.formatMessage({ id: 'SectionHero.sellNow' })}
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
        <div className={css.heroContentWrapper}>
          <div className={css.heroContentInner} style={{ backgroundImage: `url(${homeBanner2})` }}>
            <div className={css.heroContent}>
              <h1>{intl.formatMessage({ id: 'SectionHero.slide2.title' })}</h1>
              <p>{intl.formatMessage({ id: 'SectionHero.slide2.description' })}</p>
              <div className={css.btnsWrapper}>
                <PrimaryButton
                  className={classNames(css.heroButton, css.heroButtonPrimary)}
                  onClick={() => history.push('/s')}
                >
                  {intl.formatMessage({ id: 'SectionHero.shopNow' })}
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
        <div className={css.heroContentWrapper}>
          <div className={css.heroContentInner} style={{ backgroundImage: `url(${homeBanner3})` }}>
            <div className={css.heroContent}>
              <h1>{intl.formatMessage({ id: 'SectionHero.slide3.title' })}</h1>
              {intl.formatMessage({ id: 'SectionHero.slide3.description' }) ? (
                <p>{intl.formatMessage({ id: 'SectionHero.slide3.description' })}</p>
              ) : null}
              <div className={css.btnsWrapper}>
                <PrimaryButton
                  className={classNames(css.heroButton, css.heroButtonGold)}
                  onClick={() => history.push('/l/new')}
                >
                  {intl.formatMessage({ id: 'SectionHero.sellNow' })}
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
        <div className={css.heroContentWrapper}>
          <div className={css.heroContentInner} style={{ backgroundImage: `url(${homeBanner4})` }}>
            <div className={css.heroContent}>
              <h1>{intl.formatMessage({ id: 'SectionHero.slide4.title' })}</h1>
              <div className={css.testimonialCard}>
                <ReviewRating className={css.testimonialRating} />
                <p className={css.testimonialQuote}>{testimonials[activeTestimonial].quote}</p>
                <div className={css.testimonialMeta}>
                  <span>{testimonials[activeTestimonial].name}</span>
                  <span className={css.testimonialDivider}>•</span>
                  <span>{testimonials[activeTestimonial].location}</span>
                </div>
                <div className={css.testimonialDots} aria-hidden="true">
                  {testimonials.map((item, index) => (
                    <span
                      key={item.name}
                      className={classNames(css.testimonialDot, {
                        [css.testimonialDotActive]: index === activeTestimonial,
                      })}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={css.heroContentWrapper}>
          <div className={css.heroContentInner} style={{ backgroundImage: `url(${homeBanner5})` }}>
            <div className={css.heroContent}>
              <h1>{intl.formatMessage({ id: 'SectionHero.slide5.title' })}</h1>
              <p>{intl.formatMessage({ id: 'SectionHero.slide5.description' })}</p>
              <div className={css.btnsWrapper}>
                <PrimaryButton
                  className={classNames(css.heroButton, css.heroButtonPrimary)}
                  onClick={scrollToInstructors}
                >
                  {intl.formatMessage({ id: 'SectionHero.communityHome' })}
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      </Slider>
    </div>
  );
}

SectionHero.defaultProps = {
  sliderSettings: {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4500,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    focusOnSelect: false,
    centerMode: false,
    accessibility: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
        },
      },
    ],
  },
};

export default SectionHero;
